<p class="mt-3" [class.text-center]="textCenter" [class.text-end]="textRight">
  <strong>
    <ng-content></ng-content>
  </strong>
</p>
